import { Route } from 'react-router-dom'
import Unprotected from '@/routes/Unprotected'
import PATHS from '@/routes/paths'
import {
  ForgotPasswordPage,
  ResetPasswordPage,
  SignInPage,
  SignUpPage,
} from './authPages.js'

/** @returns {import('react').ReactElement[]} */
export default function authRoutes() {
  return [
    <Route
      key="sign-in"
      path={PATHS.SIGN_IN}
      element={
        <Unprotected>
          <SignInPage />
        </Unprotected>
      }
    />,
    <Route
      key="sign-up"
      path={PATHS.SIGN_UP}
      element={
        <Unprotected>
          <SignUpPage />
        </Unprotected>
      }
    />,
    <Route
      key="forgot-password"
      path={PATHS.FORGOT_PASSWORD}
      element={
        <Unprotected>
          <ForgotPasswordPage />
        </Unprotected>
      }
    />,
    // Not wrapped in Unprotected: the recovery link must open even if a stale
    // session token is present.
    <Route key="reset-password" path={PATHS.RESET_PASSWORD} element={<ResetPasswordPage />} />,
  ]
}
